import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid2, IconButton, Typography, Alert, Badge, Tooltip } from "@mui/material";
import AppButton from "../../components/CommonReusableComponent/AppButton/AppButton";
import {
  addCurrentTimeInTimeStamp,
  calculateDateDifference,
  countNCsOfAuditActivities,
  getDataForAllOption,
  getLoggedInUserAuditRole,
  getPageTitle,
  getShortFormOfAuditRole,
  setRequiredDataForDropdown,
  sortDataAlphabetically,
} from "../../common/CommonFunctions";
import { getAllAudits, getAllBranches, getAllDepartmentList, getAllDepartmentListByBranchId, getListOfAuditType, getListOfAuditTypeCategories } from "../../helpers/api-functions-helper";
import { useSnackbar } from "../../contexts/Snackbar.context";
import { useBackdrop } from "../../contexts/BackDrop.context";
import { SNACKBAR_VARIANT, ERROR_MESSAGE } from "../../config/Messages.config";
// import MUILoader from "../../components/MUILoader/MUILoader";
// import AuditMasterDataTable from "./components/AuditMasterDataTable";
// import { auditMasterDataTableColumns } from "./components/AuditMasterDataTable.config";

import { auditStatusConfig, dateFrequencyConfig, handleDateSettings } from "./components/AuditMasterDataTable.config";
import { handleOutSideDataTableSearch } from "../../common/MuiTableFunctions.config";
import MUITableSearch from "../../components/MUITable/MUITableSearch";
import Divider from "@mui/material/Divider";
import { getUserRoleAndScreens } from "../../services/authServices/auth.services";
import AppInputField from "../../components/CommonReusableComponent/AppInputField/AppInputField";
import dayjs from "dayjs";
import { Icons } from "../../config/MuiIcons.config";
import { ROLES } from "../../config/Roles.config";
// eslint-disable-next-line react/jsx-pascal-case
import AuditMasterDataTable_V2 from "./components/AuditMasterDataTable_V2";
import AppAutoCompleteField from "../../components/CommonReusableComponent/AppAutoCompleteField/AppAutoCompleteField";
import MUIDatePicker from "../../components/MUIDatePicker/MUIDatePicker";
import { AppTheme } from "../../theme/App.theme";
import InternalAuditFilterModal from "./components/InternalAuditFilterModal";

const AuditTypeMaster = () => {
  const documentTitle = getPageTitle() && getPageTitle();
  document.title = documentTitle
    ? `${documentTitle} | Zing Auditor`
    : "Zing Auditor";
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { showSnackbar } = useSnackbar();
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const { accountId, userUid, role } = getUserRoleAndScreens();
  const [tableDataInstance, setTableDataInstance] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [filterCount, setFilterCount] = useState(0);

  // Saved date settings
  const savedDateSettings = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_DEV_DATE_SETTINGS)
  )

  // All Object for selection
  const allObjWithNameId = [{ name: "All", id: "All" }];
  // const allObjWithLabelValue = [{ label: "All", value: "All" }];

  // Function to get initial data of date settings
  const getInitialDateSettings = () => {
    if (savedDateSettings && savedDateSettings?.frequency === "custom") {
      return {
        fromDate: savedDateSettings?.fromDate,
        toDate: savedDateSettings?.toDate,
      };
    } else if (savedDateSettings && savedDateSettings?.frequency) {
      const { fromDate_, toDate_ } = getDateRangeFromFrequency(savedDateSettings?.frequency, true);
      return {
        fromDate: fromDate_,
        toDate: toDate_, 
      }
    } else if (!savedDateSettings) {
      return {
        fromDate: dayjs().toISOString(),
        toDate: dayjs().add(1, "month").toISOString(),
      };
    }
  }

  // Branch
  const [branches, setBranches] = useState([]);
  // Audit Type Categories
  const [auditTypeCategories, setAuditTypeCategories] = useState([]);
  // Audit Types
  const [auditTypes, setAuditTypes] = useState([]);
  // Audit Type Instance
  const [auditTypeInstance, setAuditTypeInstance] = useState([]);
  // Departments
  const [departments, setDepartments] = useState([]);
  // Department instance
  const [deptInstance, setDeptInstance] = useState([]);
  // Filters related to audit master
  const initialFilters = {
    branchId: null,
    departmentId: null,
    auditTypeId: "All",
    auditTypeCategoryId: "All",
    status: !state?.auditStatus ? "All" : state?.auditStatus,
    fromDate: getInitialDateSettings()?.fromDate,
    toDate: getInitialDateSettings()?.toDate,
    auditFrequency: savedDateSettings?.frequency || "month",
  };
  const [filters, setFilters] = useState({ ...initialFilters });

  // loading state
  const [loadingState, setLoadingState] = useState({
    isBranchFetched: false,
    isAuditFetched: false,
    isAuditTypeCategoriesFetched: false,
    isAuditTypesFetched: false,
    isDepartmentsFetched: false,
  });

  // States for audit filter options modal
    const [isAuditFilterOptionOpen, setIsAuditFilterOptionOpen] = useState(false);

  // Hide audit filter options modal
  const toggleAuditFilterModal = () =>
    setIsAuditFilterOptionOpen((prev) => !prev);

  // Function to update loading state
  const setLoading = (key, value) => {
    setLoadingState((prev) => {
      return { ...prev, [key]: value };
    });
  };

  // search functionality
  const [searchText, setSearchText] = useState("");

  const { branchId, status, departmentId, auditFrequency, fromDate, toDate } = 
    filters;

  // User Type
  const isUser = role && role.toLowerCase() === ROLES.USER ? true : false;

  // to check user role
  const getUserRole = (AuditorId, AuditeeId) => {
    const USER_ROLE = getLoggedInUserAuditRole(AuditorId, AuditeeId);
    return USER_ROLE;
  };

  // Function to hide Create New Audit button
  const hideCreateAuditButton = () => {
    return isUser;
  };

  // Function used to filter data
  const getFilteredData = (filters, searchText, Data) => {
    const searchFilteredData = searchText
      ? handleOutSideDataTableSearch(searchText, Data)
      : !state
      ? tableDataInstance
      : Data;

    return searchFilteredData.filter((item) => {
      return Object.keys(filters)
        .filter((key) => key !== "branchId") // Exclude branchId from filtering
        .filter((key) => key !== "departmentId") // Exclude departmentId from filtering
        .filter((key) => key !== "fromDate") // Exclude fromDate from filtering
        .filter((key) => key !== "toDate") // Exclude toDate from filtering
        .filter((key) => key !== "auditFrequency") // Exclude toDate from filtering
        .every((key) => {
          if (filters[key] === "All" || !filters[key]) {
            return true; // Ignore this filter and include all values
          }

          if (!item.hasOwnProperty(key)) {
            return false; // If key doesn't exist, exclude the item
          }

          return (
            String(item[key]).toLowerCase() ===
            String(filters[key]).toLowerCase()
          );
        });
    });
  };

  // Function to filter data by field name and value
  const getFilteredDataByField = (fieldName, fieldValue) => {
    let filteredData = [];

    if (fieldName === "branchId") {
      filteredData =
        fieldValue === "All"
          ? deptInstance
          : deptInstance.filter((dept) => dept.branchId === fieldValue);

      setRequiredDataForDropdown(
        setDepartments,
        [...allObjWithNameId, ...filteredData],
        "name",
        "id"
      );
      setFilters((prev) => ({ ...prev, departmentId: "All" }));
    }

    if (fieldName === "auditTypeCategoryId") {
      filteredData =
        fieldValue === "All"
          ? auditTypeInstance
          : auditTypeInstance.filter(
              (auditType) => auditType.auditTypeCategoryId === fieldValue
            );

      setRequiredDataForDropdown(
        setAuditTypes,
        [...allObjWithNameId, ...filteredData],
        "name",
        "id"
      );
      // setFilters((prev) => ({ ...prev, auditTypeId: "All" }));
    }
  };

  // Function to change filter
  const handleChangeFilter = (Data, FieldName) => {
    setFilters((prev) => ({
      ...prev,
      [FieldName]: Data?.value || null,
    }));

    // Dynamically filter data based on the changed field
    if (["branchId", "auditTypeCategoryId"].includes(FieldName)) {
      getFilteredDataByField(FieldName, Data?.value || null);
    }

    const filtered_data = getFilteredData(
      { ...filters, [FieldName]: Data?.value || null },
      searchText,
      tableDataInstance
    );
    // setTableDataInstance(filtered_data);
    setTableData(filtered_data);
  };

  // Function to check if the audit is started or not according start date
  const isAuditStarted = (auditDate) => {
    // Get current date at 00:00:00 (ignoring time)
    const currentDate = dayjs().startOf("day");
    // Convert auditDate to same format
    const formattedAuditDate = dayjs(auditDate).startOf("day");

    // Returns true if current date >= audit date
    return (
      currentDate.isSame(formattedAuditDate) ||
      currentDate.isAfter(formattedAuditDate)
    );
  };

  // Fetch all work permit type
  // const fetchAllAudit = (BranchId, DepartmentId, FromDate, ToDate) => {
  //   setLoading("isAuditFetched", true);
  //   const payload = {
  //     fromDate: dayjs(FromDate).subtract(1, 'day').toISOString(),
  //     toDate: ToDate,
  //     branchIds: getDataForAllOption("branch", BranchId, branches),
  //     departmentIds: getDataForAllOption("department", DepartmentId, departments),
  //     userId: userUid,
  //     accountId: accountId,
  //   };
  //   getAllAudits(payload)
  //     .then((response) => {
  //       if (response && response.data) {
  //         const { statusCode, data, message, success } = response.data;
  //         if (success && statusCode === 200) {
  //           const filteredData =
  //             data && data?.length > 0
  //               ? data.map((audit) => {
  //                   const difference = calculateDateDifference(audit?.endDate);
  //                   const { closedNCs, openNCs, totalNCs } = countNCsOfAuditActivities(audit?.activityList);
  //                   return {
  //                     ...audit,
  //                     // startDate: dayjs(audit?.startDate).format("DD MMM YYYY"),
  //                     // endDate: dayjs(audit?.endDate).format("DD MMM YYYY"),
  //                     differenceInDays: difference,
  //                     userRole: getUserRole(audit?.auditorId, audit?.auditeeId),
  //                     isAuditStarted: isAuditStarted(audit?.startDate),
  //                     startAndEndDate: `${dayjs(audit?.startDate).format(
  //                       "DD MMM YYYY"
  //                     )} To ${dayjs(audit?.endDate).format("DD MMM YYYY")}`,
  //                     totalActivities: audit?.activityList?.length,
  //                     totalNCs: totalNCs,
  //                     closedNCs:
  //                       audit?.status !== "New"
  //                         ? `${closedNCs}/${totalNCs}`
  //                         : "-",
  //                     openNCs:
  //                       audit?.status !== "New"
  //                         ? `${openNCs}/${totalNCs}`
  //                         : "-",
  //                     userRoleShortForm: getShortFormOfAuditRole(
  //                       getUserRole(audit?.auditorId, audit?.auditeeId)
  //                     ),
  //                     auditTypeCategoryName: audit?.auditTypeCategoryName || "Not Available"
  //                   };
  //                 })
  //               : [];
  //           setTableDataInstance(filteredData);
  //           if (state && status !== "All") {
  //             const filterDataByAuditStatus = getFilteredData(
  //               { ...filters },
  //               searchText,
  //               filteredData
  //             );
  //             setFilterCount(1)
  //             setTableData(filterDataByAuditStatus);
  //             navigate(location.pathname, { replace: true, state: null });
  //           } else {
  //             setFilters((prev) => ({
  //               ...prev,
  //               status: "All",
  //               auditTypeId: "All",
  //               auditTypeCategoryId: "All",
  //             }));
  //             setTableData(filteredData);
  //           }
  //         } else {
  //           showSnackbar(
  //             data || message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
  //             SNACKBAR_VARIANT.ERROR
  //           );
  //           setTableData([]);
  //           setTableDataInstance([]);
  //           // setMainDataInstance([]);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("Error: ", error);
  //       showSnackbar(
  //         ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
  //         SNACKBAR_VARIANT.ERROR
  //       );
  //     })
  //     .finally(() => {
  //       setLoading("isAuditFetched", false);
  //     });
  // };

  const fetchAllAudit = async (BranchId, DepartmentId, FromDate, ToDate) => {
    try {
      setLoading("isAuditFetched", true);

      const payload = {
        fromDate: dayjs(FromDate).subtract(1, "day").toISOString(),
        toDate: ToDate,
        branchIds: getDataForAllOption("branch", BranchId, branches),
        departmentIds: getDataForAllOption(
          "department",
          DepartmentId,
          departments
        ),
        userId: userUid,
        accountId: accountId,
      };

      const response = await getAllAudits(payload);

      if (!response?.data) {
        throw new Error("Invalid response structure");
      }

      const { statusCode, data, message, success } = response.data;

      if (!success || statusCode !== 200 || !data) {
        setTableData([]);
        setTableDataInstance([]);
        throw new Error(message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      }

      if (data.length === 0) {
        setTableData([]);
        setTableDataInstance([]);
        showSnackbar(
          "No audits found for the selected filters.",
          SNACKBAR_VARIANT.INFO
        );
        return;
      }

      const filteredData = data.map((audit) => {
        const difference = calculateDateDifference(audit?.endDate);
        const { closedNCs, openNCs, totalNCs } = countNCsOfAuditActivities(
          audit?.activityList
        );
        const role = getUserRole(audit?.auditorId, audit?.auditeeId);

        return {
          ...audit,
          differenceInDays: difference,
          userRole: role,
          isAuditStarted: isAuditStarted(audit?.startDate),
          startAndEndDate: `${dayjs(audit?.startDate).format("DD MMM YYYY")} To ${dayjs(audit?.endDate).format("DD MMM YYYY")}`,
          totalActivities: audit?.activityList?.length,
          totalNCs: totalNCs,
          closedNCs: audit?.status !== "New" ? `${closedNCs}/${totalNCs}` : "-",
          openNCs: audit?.status !== "New" ? `${openNCs}/${totalNCs}` : "-",
          userRoleShortForm: getShortFormOfAuditRole(role),
          auditTypeCategoryName:
            audit?.auditTypeCategoryName || "Not Available",
        };
      });

      setTableDataInstance(filteredData);

      if (state && status !== "All") {
        const filterDataByAuditStatus = getFilteredData(
          { ...filters },
          searchText,
          filteredData
        );
        setFilterCount(1);
        setTableData(filterDataByAuditStatus);
        navigate(location.pathname, { replace: true, state: null });
      } else {
        setFilters((prev) => ({
          ...prev,
          status: "All",
          auditTypeId: "All",
          auditTypeCategoryId: "All",
        }));
        setTableData(filteredData);
      }
    } catch (error) {
      console.error("Error in fetchAllAudit:", error);
      showSnackbar(
        error.message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
        SNACKBAR_VARIANT.ERROR
      );
    } finally {
      setLoading("isAuditFetched", false);
    }
  };

  // Fetch all audit type categories
  const fetchAllAuditTypeCategories = async () => {
    try {
      setLoading("isAuditTypeCategoriesFetched", true);
      const apiResponse = await getListOfAuditTypeCategories(accountId);
      if (!apiResponse || !apiResponse.data) {
        throw new Error(ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      }

      const { statusCode, data, success, message } = apiResponse.data;

      if (!success || statusCode !== 200 || !data) {
        setAuditTypeCategories([]);
        throw new Error(message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      }

      let dataToBeSet = [...allObjWithNameId, ...data];
      setRequiredDataForDropdown(
        setAuditTypeCategories,
        dataToBeSet,
        "name",
        "id"
      );
    } catch (error) {
      console.log("Error: ", error);
      showSnackbar(ERROR_MESSAGE.FAILED_TO_FETCH_DATA, SNACKBAR_VARIANT.ERROR);
    } finally {
      setLoading("isAuditTypeCategoriesFetched", false);
    }
  };

  // Fetch all audit types
  const fetchAllAuditTypes = () => {
    setLoading("isAuditTypesFetched", true);
    getListOfAuditType(accountId)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data, success, message } = response.data;
          if (success && statusCode === 200) {
            setAuditTypeInstance(data);
            let dataToBeSet = [...allObjWithNameId, ...data];
            setRequiredDataForDropdown(
              setAuditTypes,
              dataToBeSet,
              "name",
              "id"
            );
          } else {
            setAuditTypes([]);
            setAuditTypeInstance([]);
            showSnackbar(
              data || message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
              SNACKBAR_VARIANT.ERROR
            );
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("isAuditTypesFetched", false);
      });
  };

  // Fetch all department by branch id
  const fetchAllDepartmentByAccountId = () => {
    setLoading("isDepartmentsFetched", true);
    getAllDepartmentList(accountId)
      .then((response) => {
        const { statusCode, data, message } = response?.data || {};

        if (statusCode !== 200 || !data) {
          setDepartments([]);
          setDeptInstance([]);
          showSnackbar(
            data || message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
            SNACKBAR_VARIANT.ERROR
          );
          return;
        }

        setDeptInstance(data);
        const { dashboardBranchId, dashboardDepartmentId } = state || {};
        const isAllBranches = dashboardBranchId === "All";
        const hasSelectedDept = Boolean(dashboardDepartmentId);

        // Filter only actual department data (excluding 'All')
        const filteredData =
          hasSelectedDept && !isAllBranches
            ? data.filter((dept) => dept.branchId === dashboardBranchId)
            : data;

        // Merge 'All' option with filtered data
        const finalList = sortDataAlphabetically(
          [...allObjWithNameId, ...filteredData],
          "name"
        );

        setRequiredDataForDropdown(setDepartments, finalList, "name", "id");

        setFilters((prev) => ({
          ...prev,
          departmentId: hasSelectedDept ? dashboardDepartmentId : "All",
        }));
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("isDepartmentsFetched", false);
      });
  };

  // Fetch all active branches
  const fetchAllBranches = () => {
    setLoading("isBranchFetched", true);
    getAllBranches(accountId)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data } = response.data;
          if (statusCode && statusCode === 200) {
            if (data && data?.length > 0) {
              const activeBranches = [...data].filter(
                (branch) => branch.isActive
              );
              let dataSet = [...allObjWithNameId, ...activeBranches];
              const sortedData = sortDataAlphabetically(dataSet, "name");
              setRequiredDataForDropdown(setBranches, sortedData, "name", "id");
              fetchAllDepartmentByAccountId();
              if (!state?.dashboardBranchId) {
                setFilters((prev) => ({
                  ...prev,
                  branchId: "All",
                }));
              } else {
                setFilters((prev) => ({
                  ...prev,
                  branchId: state?.dashboardBranchId,
                }));
              }
            }
          } else {
            setBranches([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("isBranchFetched", false);
      });
  };

  const getRowDataOnClickOfAction = (ActionName, Data, NavigationPath) => {
    if (ActionName === "Update Audit") {
      localStorage.setItem(
        process.env.REACT_APP_DEV_AUDIT_DATA,
        JSON.stringify(Data)
      );
      navigate(`${NavigationPath}/${Data.id}`);
    } else {
      localStorage.setItem(
        process.env.REACT_APP_DEV_AUDIT_DATA,
        JSON.stringify(Data)
      );
      navigate(`${NavigationPath}/${Data.id}`);
    }
  };

  useEffect(() => {
    if (navigator.onLine) {
      fetchAllBranches();
      fetchAllAuditTypes();
      fetchAllAuditTypeCategories();
    } else {
      showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (navigator.onLine) {
      if (branchId && departmentId && fromDate && toDate) {
        fetchAllAudit(branchId, departmentId, fromDate, toDate);
      }
    } else {
      showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId, departmentId, fromDate, toDate]);

  // Effect to change the date settings
  useEffect(() => {
    if (fromDate || toDate || auditFrequency) {
      handleDateSettings(
        fromDate,
        toDate,
        auditFrequency
      );
    }
  }, [fromDate, toDate, auditFrequency]);

  // Handle global loading state
  useEffect(() => {
    // Global loading state
    const isAllLoadingComplete = Object.values(loadingState).every(
      (status) => !status
    );

    if (!isAllLoadingComplete) {
      showBackdrop();
    } else {
      hideBackdrop();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingState]);

  // Outside Table search functionality
  useEffect(() => {
    if (searchText === "") {
      const filteredData_ = getFilteredData(
        { ...filters },
        searchText,
        tableDataInstance
      );
      setTableData(filteredData_);
    } else {
      const filteredData_ = getFilteredData(
        { ...filters },
        searchText,
        tableDataInstance
      );
      setTableData(filteredData_);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  // Function to handle audit frequency change
  function getDateRangeFromFrequency(frequency, atInitial = false) {
    let toDate;
    if (!atInitial) {
      setFilters((prev) => ({
        ...prev,
        auditFrequency: frequency,
      }));
    }

    switch (frequency) {
      case "week":
        toDate = dayjs().add(1, "week").toISOString();
        break;
      case "month":
        toDate = dayjs().add(1, "month").toISOString();
        break;
      case "quarter":
        toDate = dayjs().add(3, "month").toISOString();
        break;
      case "half-year":
        toDate = dayjs().add(6, "month").toISOString();
        break;
      case "year":
        toDate = dayjs().add(1, "year").toISOString();
        break;
      default:
        toDate = null;
    }

    return {
      fromDate_: dayjs().toISOString(),
      toDate_: toDate ? addCurrentTimeInTimeStamp(toDate) : null,
    };
  };

  // Function to apply filter on data through filter modal
  const handleApplyModalFilters = (newFiltersFromModal, filterCount = 0) => {
    const updatedFilters = { ...filters, ...newFiltersFromModal };
    setFilters(updatedFilters);
    setFilterCount(filterCount)
    const filteredData = getFilteredData(
      updatedFilters,
      searchText,
      tableDataInstance
    );

    setTableData(filteredData);
    toggleAuditFilterModal();
  };

  return (
    <React.Fragment>
      {isAuditFilterOptionOpen && (
        <InternalAuditFilterModal
          open={isAuditFilterOptionOpen}
          onClose={toggleAuditFilterModal}
          defaultFilters={{ ...filters }}
          auditTypeList={auditTypes}
          auditTypeCategoryList={auditTypeCategories}
          statusList={auditStatusConfig}
          frequencyList={dateFrequencyConfig}
          getFilteredDataByField={getFilteredDataByField}
          getDateRangeFromFrequency={getDateRangeFromFrequency}
          onApplyFilters={(data, filterCount) => {
            handleApplyModalFilters(data, filterCount);
          }}
          initialFilters={initialFilters}
        />
      )}
      <div className="page-content">
        <div>
          <Grid2
            container
            className="d-flex align-items-center my-1"
            spacing={2}
          >
            <Grid2
              size={{
                xs: 12,
                sm: !hideCreateAuditButton() ? 3 : 6,
                md: !hideCreateAuditButton() ? 4 : 6,
                lg: !hideCreateAuditButton() ? 4 : 6,
              }}
              className="py-1"
            >
              <Typography className="inter-medium-500">
                {documentTitle}
              </Typography>
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 3, md: 3, lg: 3 }} className="py-1">
              <AppAutoCompleteField
                IsMultiple={false}
                Options={branches || []}
                TextInputName={"branchId"}
                TextInputId={"branchId"}
                Id={"branchId"}
                TextInputLabel={"Select branch"}
                TextInputPlaceholder={"Select branch"}
                HandleOnChange={(event, value) => {
                  handleChangeFilter(value, "branchId");
                }}
                Value={branchId}
              />
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 3, md: 3, lg: 3 }} className="py-1">
              <AppAutoCompleteField
                IsMultiple={false}
                Options={departments || []}
                Disabled={branchId === null || branchId === "All"}
                TextInputName={"departmentId"}
                TextInputId={"departmentId"}
                Id={"departmentId"}
                TextInputLabel={"Select department"}
                TextInputPlaceholder={"Select department"}
                HandleOnChange={(event, value) => {
                  console.log("value: ", value);
                  handleChangeFilter(value, "departmentId");
                }}
                Value={departmentId}
              />
            </Grid2>

            {!hideCreateAuditButton() && (
              <Grid2 size={{ xs: 12, sm: 3, md: 2, lg: 2 }} className="py-1">
                <AppButton
                  OnPress={() => {
                    navigate("/audit-master/create");
                  }}
                >
                  Create New Audit
                </AppButton>
              </Grid2>
            )}
          </Grid2>

          <Divider
            style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
            className="mt-2"
          />
          <Grid2 container className="mt-3 mb-2" spacing={2}>
            <Grid2 size={{ xs: 10, sm: 4, md: 4, lg: 4 }}>
              <MUITableSearch
                CancelSearch={() => {
                  setSearchText("");
                }}
                HandleSearch={(e) => setSearchText(e.target.value)}
                SearchText={searchText}
              />
            </Grid2>
            <Grid2 size={{ xs: 2, sm: 1 }}>
              <Tooltip title="Filters">
                <IconButton
                    size="medium"
                    style={{
                      borderRadius: "4px",
                      border: `1px solid ${AppTheme.MUTED}`,
                    }}
                    onClick={toggleAuditFilterModal}
                  >
                    <div className="d-flex align-items-center justify-content-center">
                      <Icons.TuneOutlined fontSize="medium"/>
                      <Typography variant="body2" className="ms-1">
                        Filters
                      </Typography>
                    </div>
                  </IconButton>
                {/* <Badge
                  badgeContent={filterCount}
                  invisible={filterCount === 0}
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: AppTheme.PRIMARY_COLOR,
                      color: "white",
                    },
                  }}
                >
                  
                </Badge> */}
              </Tooltip>
            </Grid2>
          </Grid2>

          <Grid2 container className="my-2">
            <Grid2 size={12} className="mb-1">
              <Typography variant="caption">
                <strong className="me-2">User Roles:</strong>
                <strong>V</strong> - Viewer | <strong>AD</strong> - Auditor |{" "}
                <strong>AT</strong> - Auditee
              </Typography>
            </Grid2>
            <Grid2 size={12}>
              <AuditMasterDataTable_V2
                Rows={tableData || []}
                GetRowDataOnClickOfAction={getRowDataOnClickOfAction}
              />
            </Grid2>
          </Grid2>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AuditTypeMaster;
